import React from "react";
import cn from "classnames";
import * as styles from "./TemplateSingleItem.module.scss";
import {TemplateSingleItemIcon} from "../TemplateSingleItemIcon/TemplateSingleItemIcon";

function TemplateSingleItem({
  templateName,
  iconConfig,
  isIntegration = false,
  extraSmall = false,
  additionalClass = "",
  href,
  target = "_self",
  menuItem = false,
}) {
  const {iconName, fillColor, lightColor} = iconConfig;
  const TemplateSingleItem = href ? "a" : "div";

  return (
    <TemplateSingleItem
      href={href}
      target={href ? target : undefined}
      className={cn(
        styles.singleTemplateItem,
        extraSmall === true && styles._extraSmall,
        menuItem && styles.menuItem,
        additionalClass === "_inline" && styles._inline,
        additionalClass === "_verticalWithArrow" && styles._verticalWithArrow,
        additionalClass === "_small-text" && styles._smallText,
        additionalClass === "_huge" && styles._huge,
        additionalClass
      )}
    >
      {extraSmall ? (
        <>
          <span className={cn(styles.templateIconWrap, "iconWrapForHover")}>
            <TemplateSingleItemIcon {...iconConfig} onlyIcon={isIntegration} isSmall={extraSmall} />
            <span
              className={cn(
                styles.templateNameHidden,
                fillColor === "light-blue" && styles.lightBlue,
                fillColor === "aquamarine" && styles.aquamarine,
                fillColor === "dark-blue" && styles.darkBlue,
                fillColor === "blue" && styles.blue,
                fillColor === "violet" && styles.violet,
                fillColor === "plum" && styles.plum,
                fillColor === "carrot" && styles.carrot,
                fillColor === "light-green" && styles.lightGreen,
                fillColor === "green" && styles.green,
                fillColor === "pine" && styles.pine,
                fillColor === "yellow" && styles.yellow,
                fillColor === "magenta" && styles.magenta,
                fillColor === "gray" && styles.gray,
                fillColor === "dark-gray" && styles.darkGray,
                fillColor === "white" && styles.white
              )}
            >
              {templateName}
            </span>
          </span>
        </>
      ) : (
        <>
          <span className={cn(styles.templateIconWrap, "iconWrapForHover")}>
            <TemplateSingleItemIcon
              iconName={iconName}
              fillColor={fillColor}
              lightColor={lightColor}
              onlyIcon={isIntegration}
              isSmall={extraSmall}
            />
          </span>
          <span className={cn(styles.templateNameWrap)}>{templateName}</span>
        </>
      )}
    </TemplateSingleItem>
  );
}
export default TemplateSingleItem;
